<template>
	<section v-if="items.length" class="main-content contentblocks">
		<slot name="blocks-header" />
		<div v-for="item in items" :key="item.ID" class="row contentblock">
			<content-block v-if="item.backgroundImage" :item="item" type="background" />
			<content-block v-else :item="item" type="normal" />
		</div>
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.contentblocks {
	background: var(--secondary-background-color);
}

.contentblock {
	display: flex;
	flex-flow: row wrap;
	align-items: center;
	justify-content: center;
	position: relative;
	width: 100%;
	max-width: 100%;
	padding: 0;
	background: var(--primary-background-color);

	&:nth-child(odd) {
		background: var(--secondary-background-color);
	}
}
</style>
